import { render, staticRenderFns } from "./WebsiteLayout.vue?vue&type=template&id=a6eb4c76&"
import script from "./WebsiteLayout.vue?vue&type=script&lang=js&"
export * from "./WebsiteLayout.vue?vue&type=script&lang=js&"
import style0 from "../../styles/website/main.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WebsiteLayout.vue"
export default component.exports